var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.fieldComponent,_vm._g(_vm._b({tag:"component",attrs:{"label":_vm.value.attributeName,"value":_vm.value.value}},'component',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }